<!--
 * @Author: vince
 * @Date: 2021-08-18 14:26:14
 * @LastEditors: vince
 * @LastEditTime: 2021-09-04 17:34:20
 * @Description: 
-->
<template>
	<el-cascader
		size="small"
		v-if="controlType == 'select'"
		:loading="loading"
		v-model="valueTemp"
		:options="options"
		:props="props"
		filterable
		:filter-method="filterMethod"
		placeholder="请选择年级/学期"
		clearable
		@change="onChange"
	></el-cascader>
	<span v-else-if="controlType == 'checkbox'">
		<el-checkbox
			style="margin-right: 30px;"
			v-if="checkAll"
			label="全部"
			v-model="checkedAll"
			:indeterminate="indeterminate"
			@change="handleCheckedAllChange"
		></el-checkbox>
		<el-checkbox-group v-model="valueTemp" @change="onChange">
			<el-checkbox
				v-for="(item,index) in checkboxOptions"
				:key="index"
				:label="item"
			>{{ item.gradeName + '/' + item.termName }}</el-checkbox>
		</el-checkbox-group>
	</span>
</template>

<script>
import { mapGetters } from "vuex";
import { postData } from "../../http/fetch.js";
export default {
	name: "gradeTermSelector",
	model: {
		prop: "value",
		event: "change"
	},
	data() {
		return {
			loading: false,
			valueTemp: [],
			options: []
		};
	},
	watch: {
		value(v) {
			if (this.controlType == "select") {
				this.valueTemp = v.value;
			} else {
				this.valueTemp = v;
			}
		}
	},
	props: {
		controlType: {
			type: String,
			default: "select"
		},
		props: {
			type: Object,
			default: () => {
				return {
					multiple: false,
					expandTrigger: "hover"
				};
			}
		},
		value: {
			type: Object | Array,
			default: () => {
				return {
					gradeName: "",
					value: []
				};
			}
		}
	},
	computed: {
		...mapGetters(["schoolCode"]),
		checkboxOptions() {
			let opts = [];
			this.options.forEach(f => {
				opts = opts.concat([
					{ grade: f.value, gradeName: f.label, term: 1, termName: "上" },
					{ grade: f.value, gradeName: f.label, term: 2, termName: "下" }
				]);
			});
			return opts;
		}
	},
	created() {
		if (this.controlType == "select" && this.value) {
			this.valueTemp = this.value.value;
		}
		if (this.controlType == "checkbox" && this.value) {
			this.valueTemp = this.value;
		}
		this.getGradeList();
	},
	methods: {
		onChange(v) {
			let grade = this.options.find(f => {
				return f.value == v[0];
			});
			if (this.controlType == "select") {
				this.$emit("change", {
					grade: grade,
					value: v
				});
			} else if (this.controlType == "checkbox") {
				this.$emit("change", v);
			}
		},
		async getGradeList() {
			this.loading = true;
			return new Promise((resolve, reject) => {
				postData("/school/getGradeList", { schoolCode: this.schoolCode })
					.then(res => {
						let list = [];
						if (res.length) {
							list = res.map(m => {
								m = {
									label: m.gradeName,
									value: m.grade,
									children: [
										{ label: "上", value: 1 },
										{ label: "下", value: 2 }
									]
								};
								return m;
							});
							this.options = list;
							resolve(list);
						} else {
							this.options = [];
							reject();
						}
					})
					.catch(e => {
						reject(e);
					})
					.finally(() => {
						this.loading = false;
					});
			});
		},
		async filterMethod(node, query) {
			if (this.options.length == 0) {
				await this.getGradeList();
			}
			return false;
		}
	}
};
</script>

<style>
</style>